import { Award } from "lucide-react";
import { Badge } from "./ui/badge";

export function hostSinceLabel(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d) ? null : d.toLocaleDateString(undefined, { month: "short", year: "numeric" });
}

export default function TrustBadges({ car, compact = false }) {
  const since = hostSinceLabel(car.host_since);
  if (!since) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? "" : "mt-3"}`} data-testid={`trust-badges-${car.car_id}`}>
      <Badge data-testid={`badge-host-since-${car.car_id}`} className="bg-slate-900/80 text-slate-200 border border-slate-700 backdrop-blur-md font-mono text-[10px] tracking-wider uppercase">
        <Award className="w-3 h-3 mr-1 text-amber-400" />Host since {since}
      </Badge>
    </div>
  );
}
